import { render, staticRenderFns } from "./LoginFlowStepOTP.vue?vue&type=template&id=412a7d45&scoped=true&"
import script from "./LoginFlowStepOTP.vue?vue&type=script&lang=ts&"
export * from "./LoginFlowStepOTP.vue?vue&type=script&lang=ts&"
import style0 from "./LoginFlowStepOTP.vue?vue&type=style&index=0&id=412a7d45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412a7d45",
  null
  
)

export default component.exports